import { FC } from 'react';
import { RoyaltyChecksTable } from 'pages/royalty-checks/shared/royalty-checks-table';
import { EntityResponse } from 'types/api-responses';

const EntityRoyaltyChecks: FC<{ entity: EntityResponse }> = ({ entity }) => (
  <RoyaltyChecksTable
    scope={{ entityId: entity.id }}
    persistenceKey={`entity-${entity.id}-royalty-checks-table`}
  />
);

export { EntityRoyaltyChecks };
